import React from 'react';
import { TextField, FormControl, Button, MenuItem } from '@mui/material';

const TextInputWithButton = (props) => {
  const { onClick, label, placeholder, options = [] } = props || {};
  const [text, setText] = React.useState('');
  const [option, setOption] = React.useState(options[0]);

  const onChange = (e) => {
    setText(e.target.value);
  };

  const onOptionChange = (e) => {
    setOption(e.target.value);
  };

  return (
    <FormControl fullWidth>
      <div style={{ display: 'flex' }}>
        <TextField
          fullWidth
          onChange={onChange}
          variant="outlined"
          value={text}
          style={{ marginLeft: '6px', marginRight: '6px' }}
          placeholder={placeholder}
          onSubmit={() => onClick(text, option)}
        />
        {options.length ? (
          <TextField
            id="option"
            variant="outlined"
            select
            onChange={onOptionChange}
            defaultValue={options[0]}
            style={{ marginLeft: '6px', marginRight: '6px', width: '20%' }}
          >
            {options.map((value) => {
              return (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              );
            })}
          </TextField>
        ) : null}
        <Button
          variant="outlined"
          style={{ marginLeft: '6px', marginRight: '6px' }}
          onClick={() => onClick(text, option)}
        >
          {label}
        </Button>
      </div>
    </FormControl>
  );
};

export default TextInputWithButton;